import React, { useState, FC, Fragment } from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Card, CardContent, Paper } from '@mui/material';
import { IPlatMap } from '../../models';
import { ImageModal } from '..';

interface IImageUploader {
  images: string[] | IPlatMap[];
  setFieldValue;
  photoType: string;
}

export const ImageUploader: FC<IImageUploader> = ({ images, setFieldValue, photoType }) => {
  const classes = useStyles();
  const [source, setSource] = useState<string>('');
  const [isShowingImage, showImage] = useState<boolean>(false);
  return (
    <Grid container spacing={1}>
      {images.map((image, index) => {
        return (
          <Fragment key={`${index}`}>
            <Grid key={`${index}-image-${photoType}`} item xs={12} md={4} xl={3}>
              <Card className={classes.hover} elevation={0} variant="outlined">
                <CardContent>
                  <Paper elevation={0} square>
                    <div>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          xs={12}
                          onClick={() => {
                            setSource(image && image.imageUrl ? image.imageUrl : image);
                            showImage(true);
                          }}
                        >
                          <img
                            className={classes.pics}
                            key={`${index}`}
                            alt={`${photoType}-${index}`}
                            src={image && image.imageUrl ? image.imageUrl : image}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Paper>
                </CardContent>
              </Card>
            </Grid>
            <ImageModal isOpen={isShowingImage} onClose={() => showImage(false)} source={source} />
          </Fragment>
        );
      })}
    </Grid>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  buttonGroup: {
    marginTop: theme.spacing(1)
  },
  logoDrop: {
    marginTop: theme.spacing(1),
    marginBottom: 0
  },
  logoUploaded: {
    margin: theme.spacing(1, 0, 0)
  },
  editButtonsWrapper: {
    margin: theme.spacing(1, 0),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-around'
  },
  editButtonGroup: {
    flex: 1
  },
  colorLabel: {
    marginRight: '1rem'
  },
  optionsButtonsWrapper: {
    margin: theme.spacing(1, 0),
    display: 'flex',
    alignItems: 'center'
  },
  optionsGroup: {
    display: 'flex',
    backgroundColor: theme.palette.grey[300],
    padding: '.5rem',
    alignItems: 'center'
  },
  removeWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(0.5)
  },
  removeButton: {
    color: theme.palette.error.main
  },
  select: {
    flex: 1
  },
  pics: {
    display: 'block',
    margin: '0 auto',
    maxHeight: 125,
    maxWidth: '100%'
  },
  truncate: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  hover: {
    cursor: 'pointer'
  }
}));
